import React, { useState } from 'react';
import {
  Box, Typography, Stack, Button, Grid, IconButton, Paper, TextField, InputAdornment, List, ListItemButton,
  ListItemIcon, ListItemText, Collapse, Avatar, Fab
} from '@mui/material';
import {
  NoteAddOutlined, PushPinOutlined, LabelOutlined, AutoAwesomeOutlined, LoopOutlined, DeleteOutline,
  ChevronRight, KeyboardArrowDown, Remove, AspectRatio, Search
} from '@mui/icons-material';


const NotesApp = () => {
  // State to manage the expanded notebook
  const [open, setOpen] = useState(true);

  const handleNotebookClick = () => {
    setOpen(!open);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Paper elevation={4} sx={{ borderRadius: 3, overflow: 'hidden' }}>
        
        {/* Window Title Bar */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 1.5,
            bgcolor: 'background.default',
          }}
        >
          <Typography variant="h6" fontWeight="500" color="secondary.main">
            Notes
          </Typography>
          <Stack direction="row">
            <IconButton size="small"><Remove sx={{color: 'secondary.light'}} /></IconButton>
            <IconButton size="small"><AspectRatio sx={{color: 'secondary.light'}} /></IconButton>
          </Stack>
        </Box>

        {/* Main Content Grid */}
        <Grid container>
          {/* Left Sidebar */}
          <Grid item xs={12} md={3.5} sx={{ bgcolor: 'white', p: 2 }}>
            <Stack spacing={2}>
              <Button variant="contained" startIcon={<NoteAddOutlined />} fullWidth sx={{ py: 1.5 }}>
                New Notebook
              </Button>
              
              <List component="nav" sx={{ p: 0 }}>
                <ListItemButton
                  selected
                  sx={{
                    borderRadius: 2,
                    '&.Mui-selected': {
                      bgcolor: 'background.default',
                      color: 'secondary.main',
                      '& .MuiListItemIcon-root': { color: 'primary.main' },
                    },
                    borderLeft: '3px solid',
                    borderColor: 'primary.main',
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 36 }}><PushPinOutlined /></ListItemIcon>
                  <ListItemText primary="Important Notes" primaryTypographyProps={{ fontWeight: 500 }} />
                </ListItemButton>
                <ListItemButton sx={{ borderRadius: 2 }}>
                  <ListItemIcon sx={{ minWidth: 36 }}><LabelOutlined sx={{ transform: 'rotate(90deg)' }} /></ListItemIcon>
                  <ListItemText primary="Tags" primaryTypographyProps={{ fontWeight: 500, color: 'secondary.light' }} />
                </ListItemButton>
              </List>
              
              <Box>
                <Typography variant="h6" fontWeight="bold" sx={{ my: 1 }}>
                  My Notebooks
                </Typography>
                <List component="nav" sx={{ p: 0 }}>
                  <ListItemButton sx={{ borderRadius: 2 }}>
                    <ListItemIcon sx={{ minWidth: 24 }}><ChevronRight fontSize="small" /></ListItemIcon>
                    <ListItemIcon sx={{ minWidth: 36 }}><AutoAwesomeOutlined color="action" /></ListItemIcon>
                    <ListItemText primary="Other Notes" primaryTypographyProps={{ color: 'secondary.light' }} />
                  </ListItemButton>
                  
                  <ListItemButton onClick={handleNotebookClick} sx={{ borderRadius: 2 }}>
                    <ListItemIcon sx={{ minWidth: 24 }}>
                      {open ? <KeyboardArrowDown fontSize="small" /> : <ChevronRight fontSize="small" />}
                    </ListItemIcon>
                    <ListItemIcon sx={{ minWidth: 36 }}><AutoAwesomeOutlined color="action" /></ListItemIcon>
                    <ListItemText primary="ML: Intro to Time Series ..." primaryTypographyProps={{ color: 'secondary.light' }} />
                  </ListItemButton>
                  <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItemButton sx={{ pl: 4, borderRadius: 2 }}>
                        <ListItemIcon sx={{ minWidth: 36 }}><LoopOutlined color="action" /></ListItemIcon>
                        <ListItemText primary="Rolling moving ..." primaryTypographyProps={{ color: 'secondary.light' }} />
                        <IconButton size="small"><DeleteOutline fontSize="small" color="action" /></IconButton>
                      </ListItemButton>
                    </List>
                  </Collapse>
                </List>
              </Box>
            </Stack>
          </Grid>
          
          {/* Right Content Area */}
          <Grid item xs={12} md={8.5} sx={{ bgcolor: 'background.default', position: 'relative' }}>
            <Box sx={{ p: 2 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                    <Stack direction="row" alignItems="center" spacing={1.5}>
                        <PushPinOutlined color="action" />
                        <Typography variant="body1" fontWeight="bold" color="secondary.main">
                            Important Notes
                        </Typography>
                    </Stack>
                    <TextField
                        variant="standard"
                        placeholder="search"
                        sx={{
                            bgcolor: 'white',
                            borderRadius: '8px',
                            px: 1.5,
                            py: 0.5,
                            width: 250
                        }}
                        InputProps={{
                            disableUnderline: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Search color="action" />
                                </InputAdornment>
                            )
                        }}
                    />
                </Stack>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
                <Typography variant="body1" color="secondary.light">
                    You haven't marked any important notes yet!
                </Typography>
            </Box>

            <Fab sx={{
                position: 'absolute',
                bottom: 24,
                right: 24,
                bgcolor: '#1C2E5E', // A dark blue
                '&:hover': {
                    bgcolor: '#15244a'
                }
            }}>
                <Avatar src="https://d2beiqkhq929f0.cloudfront.net/public_assets/assets/000/064/633/original/Vector.png?1700551025" sx={{ width: 28, height: 28 }} />
            </Fab>

          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default NotesApp;